import { render, staticRenderFns } from "./InvoiceDueCollection.vue?vue&type=template&id=8b29a4cc&scoped=true"
import script from "./InvoiceDueCollection.vue?vue&type=script&lang=js"
export * from "./InvoiceDueCollection.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDueCollection.vue?vue&type=style&index=0&id=8b29a4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b29a4cc",
  null
  
)

export default component.exports